import { initTabsScrollsar } from './modules/scrollbar/tabs-nav-scrollbar';

document.addEventListener('DOMContentLoaded', () => {
    $('[name="city-select"]').on('change', function () {
        $('.roaster-contact__city.active').removeClass('active');
        $(`#${$(this).val()}`).addClass('active');
    });

    function createTabs() {
        const tabLinks = Array.from(document.querySelectorAll('.tab-pane')).map((tab) => `<a class="nav-item nav-link" data-toggle="tab" href="#${tab.id}">${tab.dataset.title}</a>`);

        if (!tabLinks.length) return;

        const tabNav = `<div class="nav-tabs-wr">
                             <div class="nav nav-tabs" id="roaster-tabs">
                             ${tabLinks.join('')}
                             </div>
                       </div>`;

        $('.app-tabs').prepend(tabNav);
        initTabsScrollsar();
        $('#roaster-tabs .nav-item:first-child').tab('show');
    }

    createTabs();
});
